// Dependencies
import React from 'react';
import { useTranslation } from 'react-i18next';

import './Error.css';
import logo from '../../images/logos/obok-logo.png';

function Error() {
  const { t } = useTranslation();
  return (
    <div className="container-fluid">
      <div className="row align-items-center justify-content-center">
        <div className="d-flex flex-column align-items-center justify-content-center col-12 col-md-5 col-lg-6 col-xl-4 px-lg-6 my-5">
          <div className="p-5">
            <img src={logo} className="img-fluid" alt="Hypercube's logo" />
          </div>
          <p data-testid="visible" className="text-muted text-center mb-3 mr-1">
            {t('views.error.error.theres')}
          </p>
          <p className="text-muted text-center mb-3">
            <span>{t('views.error.error.looks')}</span>
          </p>
          <a href="/dashboard" className="btn btn-sm btn-primary">
            {t('views.error.error.goBack')}
          </a>
        </div>
        <div className="col-12 col-md-7 col-lg-6 col-xl-8 d-none d-lg-block">
          <div id="bg-error" className="vh-100 mt-n1 mr-n3" />
        </div>
      </div>
    </div>
  );
}

export default Error;
